module.exports = __webpack_public_path__ + "static/media/gray-logo.147551da.png";